// OverlayUI.js

import React from 'react';

const OverlayUI = ({ viz }) => {
  return (
    <>
      <div className="overlay-info-box">
        {/* --- CHANGE HERE --- */}
        {/* Conditionally render the subject */}
        {viz.subjectName && <h5 className="viz-subject">{viz.subjectName}</h5>}
        <h4 className="viz-title">{viz.name}</h4>
      </div>
    </>
  );
};

export default OverlayUI;